import type { ReferenceSelections } from "./ReferencePickerModal";
import { assignPromptImageTags } from "@shared/promptImageTags";

/** Keep the lead decision visible beside the composer, before planning costs credits. */
export function LeadCharacterSelect({
  selected,
  onChange,
}: {
  selected: ReferenceSelections;
  onChange: (next: ReferenceSelections) => void;
}) {
  const refs = assignPromptImageTags(selected.references ?? []);
  const characters = refs.filter((ref) => ref.role === "character");
  if (characters.length < 2) return null;
  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "var(--fg-dim)",
      }}
    >
      Lead character
      <select
        aria-label="Lead character"
        title="Choose the lead character. Describe who sings each part in your prompt for a duet."
        value={characters[0].imageUrl}
        onChange={(event) => {
          const lead = characters.find(
            (ref) => ref.imageUrl === event.target.value,
          );
          if (lead)
            onChange({
              references: [
                lead,
                ...refs.filter((ref) => ref.imageUrl !== lead.imageUrl),
              ],
            });
        }}
        style={{
          maxWidth: 170,
          padding: "7px 9px",
          borderRadius: 8,
          background: "var(--panel-2)",
          color: "var(--fg)",
          border: "1px solid var(--line-2)",
        }}
      >
        {characters.map((ref) => (
          <option key={ref.imageUrl} value={ref.imageUrl}>
            @{ref.tag} · {ref.name}
          </option>
        ))}
      </select>
    </label>
  );
}
